import { ChangeEvent } from 'react'
import { useTranslation } from 'next-i18next'

import { SessionStatus } from '~/types/tutoring-api'
import { getSessionStatusColor } from '~/panels/utils/panels.utils'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import ChevronDownIcon from '~/components/Icons/svgs/ChevronDownIcon'

export default function SessionStatusSelect({
  status,
  onChange,
}: {
  status: SessionStatus
  onChange: (event: ChangeEvent<HTMLSelectElement>) => void
}): React.ReactElement {
  const { t } = useTranslation('sessionStatus')

  return (
    <Select
      className="w-full p-1 border border-gray-light rounded-medium"
      innerClassName={getSessionStatusColor(status)}
      onChange={onChange}
      value={status}
    >
      {Object.values(SessionStatus).map((sessionStatus) => (
        <option key={sessionStatus} value={sessionStatus}>
          {t(sessionStatus)}
        </option>
      ))}
    </Select>
  )
}

function Select({
  children,
  className,
  innerClassName,
  name,
  onChange,
  value,
}: {
  children: React.ReactElement | React.ReactElement[]
  className?: string
  innerClassName?: string
  name?: string
  onChange: (event: ChangeEvent<HTMLSelectElement>) => void
  value: string
}): React.ReactElement {
  return (
    <div className={`relative mx-auto inline-block ${className}`}>
      <select
        className={`w-full pr-8 appearance-none bg-transparent cursor-pointer ${innerClassName}`}
        name={name}
        onChange={onChange}
        value={value}
      >
        {children}
      </select>
      <div className="absolute inset-y-0 right-1 flex items-center pointer-events-none">
        <div className="w-5 h-5 flex items-center justify-center rounded-full bg-blue-iris">
          <SVGIcon icon={ChevronDownIcon} pathClassName="text-white" size={12} />
        </div>
      </div>
    </div>
  )
}
